/* eslint import/no-named-as-default-member: 0 */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Translation, useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Pagination from 'components/v2/Pagination';
import { COMPLETE_STOP, PROVIDE_POD, ADD_CONTAINER, CONFIRM_APPT, ENTER_REQUIRED_DATES, SCHEDULE_APPT, PROVIDE_ARRIVAL_INFORMATION, ADD_DOCUMENTS, } from 'constants/next-actions';
import { showToast } from 'stores/ToastStore';
import SessionStore from 'stores/SessionStore';
import { getShipperStopDocumentRequirementsFromConfig, getUniqueCombinedStopDocumentRequirementsFromConfig, } from 'helpers/stops';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
import { isIntermodalShipmentType } from 'helpers/shipment-types';
import MinimumDocumentRequirements from 'components/modules/shipments/MinimumDocumentRequirements';
import CargomaticModal from 'components/v2/modal';
import Alert from 'components/ui/Alert';
import NextAction from './NextAction';
import StopCompleteModal from '../shipments/stops/StopCompleteModal';
import StopEquipmentModal from '../shipments/stops/StopEquipmentModal';
import AddAppointmentModal from '../../ui/tailwind/modals/AddAppointmentModal';
import ShipmentWebAPIUtils, { completeStop, } from '../../../utils/ShipmentWebAPIUtils';
import StopArrivedModal from '../shipments/stops/StopArrivedModal';
import ShipmentsActionCreators from '../../../actions/ShipmentsActionCreators';
import { FEATURE_FLAG_ENABLED_BREADCRUMB } from 'constants/temp-feature-flag-breadcrumb';
const ACTIONS_WITHOUT_EDIT = [CONFIRM_APPT];
export default function NextActionsList({ actions, actionType2, isCustomerView, perPage, page, pages, total, onPageClick, setIsModalOpen, onShipmentClosed, selectedAction, setSelectedAction, setShipmentUpdatedOnModalClose, }) {
    const history = useHistory();
    const user = SessionStore.getUser();
    const { t } = useTranslation();
    const setRedirect = (path) => history.push(path);
    const [shipperStopDocumentRequirements, setShipperStopDocumentRequirements] = useState({});
    useEffect(() => {
        var _a;
        if ((selectedAction === null || selectedAction === void 0 ? void 0 : selectedAction.shipment) &&
            featureEnabled(CONFIGURED_FEATURES.SSR) &&
            isIntermodalShipmentType(selectedAction === null || selectedAction === void 0 ? void 0 : selectedAction.shipment) &&
            ((_a = selectedAction === null || selectedAction === void 0 ? void 0 : selectedAction.shipment) === null || _a === void 0 ? void 0 : _a.shipper)) {
            const getShipperStopDocRequirements = async () => {
                const { shipper } = selectedAction.shipment;
                const shipperId = (shipper === null || shipper === void 0 ? void 0 : shipper._id) || shipper;
                const isCarrierMandatoryStopDocumentsEnabled = featureEnabled(CONFIGURED_FEATURES.CARRIER_MANDATORY_STOP_DOCUMENTS);
                const lookup = isCarrierMandatoryStopDocumentsEnabled
                    ? await getUniqueCombinedStopDocumentRequirementsFromConfig(shipperId)
                    : await getShipperStopDocumentRequirementsFromConfig(shipperId);
                setShipperStopDocumentRequirements(lookup);
            };
            getShipperStopDocRequirements();
        }
    }, [selectedAction]);
    function handleNextActionClick(action) {
        setIsModalOpen(true);
        setSelectedAction(action);
        handlePageClickRedirect(action);
    }
    function handleCloseNextActionModal() {
        setIsModalOpen(false);
        setSelectedAction(null);
    }
    function handlePageClick(selectedPage) {
        onPageClick(selectedPage);
    }
    function handlePageClickRedirect({ action, shipment }) {
        if (action === ENTER_REQUIRED_DATES) {
            console.log('USER TYPE: ', user._type);
            const link = user._type === 'Admin'
                ? `/shipments/${shipment._id}`
                : `/shipments/${shipment._id}?action=set_dates`;
            console.log('LINK: ', link);
            setRedirect(link);
        }
    }
    async function handleStopComplete(shipment, stop, file, meta) {
        try {
            const response = await completeStop(shipment, stop, file, meta);
            if (stop.action === 'deliver' &&
                response.entity.job.status === 'job_closed') {
                onShipmentClosed(shipment);
            }
            handleCloseNextActionModal();
            setShipmentUpdatedOnModalClose(true);
            showToast(t(COMPLETE_STOP), t('COMPLETE_STOP_SUCCESS'));
        }
        catch (e) {
            console.error(e);
            showToast(t(COMPLETE_STOP), t('COMPLETE_STOP_FAIL'), 'error');
        }
    }
    function handleStopEquipmentUpdateSuccess() {
        if (selectedAction.action === ADD_CONTAINER) {
            handleCloseNextActionModal();
            setShipmentUpdatedOnModalClose(true);
        }
        showToast(t(COMPLETE_STOP), t('ADD_CONTAINER_SUCCESS'));
    }
    function handleStopEquipmentUpdateFail(e) {
        console.error(e);
        showToast(t(COMPLETE_STOP), t('ADD_CONTAINER_FAIL'), 'error');
    }
    async function handleScheduleAppt(updates) {
        try {
            const response = await ShipmentWebAPIUtils.updateShipmentStopSchedulingResponse(selectedAction.shipment, selectedAction.nextStop, updates);
            if (response.entity.success) {
                showToast(t(PROVIDE_POD), t('SCHEDULE_APPT_SUCCESS'));
                handleCloseNextActionModal();
                setShipmentUpdatedOnModalClose(true);
            }
            else {
                throw new Error(t('ERROR_UPDATING_APPOINTMENT'));
            }
        }
        catch (e) {
            console.error(e);
            showToast(t('SCHEDULE_APPOINTMENT'), t('SCHEDULE_APPT_FAIL'), 'error');
        }
    }
    function renderWarningForAccessorialDocumentsConitionally(shipment) {
        var _a;
        if ((_a = shipment.accessorial) === null || _a === void 0 ? void 0 : _a.some((acc) => acc.missing_docs === true && !FEATURE_FLAG_ENABLED_BREADCRUMB)) {
            return (React.createElement(Alert, { type: "warning", className: "m-4" },
                React.createElement(Translation, null, (t, { i18n }) => (React.createElement(React.Fragment, null, t('ACCESSORIAL_DOCUMENTS_MUST_BE_UPLOADED_WITHIN_48_HOURS_OF_DELIVERY_OR_WILL_BE_AUTO-DECLINED'))))));
        }
        return null;
    }
    function renderActionModal() {
        var _a;
        if (!selectedAction) {
            return null;
        }
        if (selectedAction.action === SCHEDULE_APPT ||
            selectedAction.action === CONFIRM_APPT) {
            return (React.createElement(AddAppointmentModal, { stop: selectedAction.nextStop, shipment: selectedAction.shipment, show: !!selectedAction, onSave: handleScheduleAppt, onHide: handleCloseNextActionModal }));
        }
        if (selectedAction.action === ENTER_REQUIRED_DATES) {
            return null;
        }
        if (selectedAction.action === ADD_CONTAINER) {
            return (React.createElement(StopEquipmentModal, { show: !!selectedAction, shipmentId: selectedAction.shipment._id, stopId: selectedAction.nextStop._id, onStopEquipmentUpdateSuccess: handleStopEquipmentUpdateSuccess, onStopEquipmentUpdateFail: handleStopEquipmentUpdateFail, onHide: handleCloseNextActionModal, isCarrier: isCustomerView }));
        }
        if (selectedAction.action === PROVIDE_ARRIVAL_INFORMATION) {
            return (React.createElement(StopArrivedModal, { shipmentId: selectedAction.shipment._id, stopId: selectedAction.nextStop._id, show: !!selectedAction, onHide: handleCloseNextActionModal, onStopArrived: ShipmentsActionCreators.transitionStop }));
        }
        const isDrayageDocumentRequirements = selectedAction.action === ADD_DOCUMENTS &&
            ((_a = selectedAction === null || selectedAction === void 0 ? void 0 : selectedAction.shipment) === null || _a === void 0 ? void 0 : _a.shipment_type) !== 'shorthaul';
        if (isDrayageDocumentRequirements) {
            return (React.createElement(CargomaticModal, { size: "large", style: { paddingTop: 200 }, title: t('PROVIDE_SHIPMENT_DOCUMENTS'), onHide: handleCloseNextActionModal },
                React.createElement("div", null,
                    renderWarningForAccessorialDocumentsConitionally(selectedAction.shipment),
                    React.createElement("div", { style: { padding: 20 } },
                        React.createElement(MinimumDocumentRequirements, { shipment: selectedAction.shipment, title: "PLEASE_PROVIDE_THE_FOLLOWING_DOCUMENTS" })))));
        }
        return (React.createElement(StopCompleteModal, { show: !!selectedAction, shipmentId: selectedAction.shipment._id, stopId: selectedAction.nextStop._id, onStopComplete: handleStopComplete, onHide: handleCloseNextActionModal, onStopEquipmentUpdateSuccess: handleStopEquipmentUpdateSuccess, onStopEquipmentUpdateFail: handleStopEquipmentUpdateFail, isCarrier: isCustomerView, shipperStopDocumentRequirements: shipperStopDocumentRequirements }));
    }
    return (React.createElement("div", { className: "divide-y divide-gray-200 divide-solid" },
        actions.map((action, i) => {
            var _a;
            return (React.createElement(NextAction, { action: action, actionType: action, nextAction: ((_a = action.nextStop) === null || _a === void 0 ? void 0 : _a.action) || action.action, isCustomerView: isCustomerView, onNextActionClick: handleNextActionClick, key: i, hideEdit: ACTIONS_WITHOUT_EDIT.includes(action.action) }));
        }),
        total > 0 && (React.createElement(Pagination, { className: "", perPage: perPage, page: page, pages: pages, total: total, onPageClick: handlePageClick })),
        renderActionModal()));
}
NextActionsList.propTypes = {
    actions: PropTypes.arrayOf(PropTypes.shape({
        _id: PropTypes.string,
        shipment_id: PropTypes.string,
        equipment: PropTypes.string,
        shipper: PropTypes.shape({
            _id: PropTypes.string,
            company_name: PropTypes.string,
        }),
        carrier: PropTypes.shape({
            _id: PropTypes.string,
            name: PropTypes.string,
        }),
        actionMessage: PropTypes.string,
    })),
    isCustomerView: PropTypes.bool,
    page: PropTypes.number,
    pages: PropTypes.number,
    perPage: PropTypes.number,
    total: PropTypes.number.isRequired,
};
NextActionsList.defaultProps = {
    isCustomerView: true,
    page: 1,
    pages: 1,
    perPage: 10,
};
